var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxSeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 214,
    viewBox: "0 0 214 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.488 14.8833C107.891 14.2434 106.109 14.2434 104.512 14.8833L24.6902 46.8094L56.8438 59.6628L139.154 26.7469L109.488 14.8833ZM157.156 33.956L74.8465 66.8719L107 79.7253L189.31 46.8094L157.156 33.956ZM200.625 56.6935L113.688 91.4685V197.425L200.625 162.65V56.7069V56.6935ZM100.312 197.439V91.4552L13.375 56.6935V162.664L100.312 197.439ZM99.5501 2.45791C104.333 0.545279 109.667 0.545279 114.45 2.45791L209.8 40.6034C211.04 41.1002 212.102 41.9569 212.851 43.0629C213.6 44.169 214 45.4739 214 46.8094V162.664C213.998 165.336 213.196 167.947 211.696 170.159C210.197 172.372 208.069 174.084 205.587 175.076L109.488 213.515C107.891 214.155 106.109 214.155 104.512 213.515L8.42625 175.076C5.94186 174.086 3.8111 172.375 2.30909 170.162C0.80707 167.95 0.00275965 165.338 0 162.664L0 46.8094C0.000310834 45.4739 0.400498 44.169 1.14901 43.0629C1.89751 41.9569 2.96006 41.1002 4.19975 40.6034L99.5501 2.45791Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxSeam);
export default __webpack_public_path__ + "static/media/box-seam.a9edfe6c4c9a9dd433eed7f9a6911006.svg";
export { ForwardRef as ReactComponent };